import { render, staticRenderFns } from "./ChatSock.vue?vue&type=template&id=2bf8e42a&scoped=true"
import script from "./ChatSock.vue?vue&type=script&lang=ts"
export * from "./ChatSock.vue?vue&type=script&lang=ts"
import style0 from "./ChatSock.vue?vue&type=style&index=0&id=2bf8e42a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf8e42a",
  null
  
)

export default component.exports